import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import LoadingComponent from "../tools/loading.js";

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = useSelector((state) => state.isLoggedIn);
  // const isLoggedIn = true;
  const isRehydrated = useSelector((state) => state._persist.rehydrated);
  const user = useSelector((state) => state.user);

  if (!isRehydrated) {
    return <LoadingComponent />;
  }

  if (!isLoggedIn && !user) {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute;
